/**
 * Video Playback Script.
 **/

( function() {

	const videoButton = document.getElementById('VideoToggle');
	const	video = document.getElementById('HeroVideo');

	if(video) {

		// Toggle playback on background videos.
		videoButton.addEventListener( 'click', toggleVideoPlayback );

		/**
		 * Toggle video playback when the button is pressed.
		 */
		function toggleVideoPlayback() {

			videoButton.classList.toggle('paused');

			if (!video.paused) {
				video.pause();
			} else {
				video.play();
			}

		}

	}

}() );
